import React from "react";

export const CreditReportError = ({ className, errorMessage }: { className?: string, errorMessage?: string }) => {
  return (
    <div
      className={`w-full min-h-[520px] bg-neutral-200 flex flex-col justify-center items-center p-6 ${
        className || ""
      }`}
      style={{ borderRadius: 10 }}
    >
      <p className="max-w-[418px] text-center text-neutral-600">
        Something went wrong, please try again later. <br />
        If issue persists, contact our support team for assistance.
      </p>
      <p className="mt-2 text-neutral-600">{errorMessage}</p>
    </div>
  );
};

CreditReportError.defaultProps = {
  className: "",
  errorMessage: "",
};
